import htmlToPdfmake from "html-to-pdfmake"
import { LangType } from "client/store"
import { MtProject, SilSafetyFunction } from "server/models"
import * as Const from "client/components/pdfmake/template/const"

const OverviewPage = (
    safetyFunctions: readonly SilSafetyFunction[],
    project: MtProject,
    lang: LangType,
) => {
    const safetyFunctionList: string[] = []
    safetyFunctions.forEach((safetyFunction) => {
        safetyFunctionList.push(safetyFunction.name)
    })

    return [
        {
            pageBreak: "before",
            style: Const.HEADER,
            text: project.name,
        },
        {
            style: Const.SUB_HEADER,
            text: `1.   ${lang.projectDescription}`,
            ...Const.TOC_HEADER_BASE,
        },
        {
            style: Const.PARAGRAPH,
            stack: htmlToPdfmake(project.description),
        },
        {
            style: Const.SUB_HEADER,
            text: `2.   ${lang.safetyFunctions}`,
            ...Const.TOC_HEADER_BASE,
        },
        {
            style: Const.PARAGRAPH,
            text: lang.safetyFunctionsReport,
            italics: true,
            margin: [0, 5, 0, 10],
        },
        {
            style: Const.LIST,
            ul: safetyFunctionList,
        },
    ] as any[]
}
export default OverviewPage
